import { navigateInternally } from './navigate-internally'

export function useInternalLinkClickHandler(overrideHref?: string) {
  return (event: Event) => {
    const target = event.target

    let targetHref: string | null = null
    if (target instanceof HTMLAnchorElement) {
      targetHref = target.href
    }

    if (overrideHref) {
      targetHref = overrideHref
    }

    if (!targetHref) return

    if (navigateInternally(targetHref)) {
      event.preventDefault()
    }
  }
}
